import { Component, OnInit, ViewEncapsulation, OnDestroy, HostListener } from '@angular/core';
import { environment } from '../../environments/environment';
import { BannerService } from '../services/banner.service';
import { Router, NavigationEnd } from '@angular/router';
import { EmitterService } from '.././services/emitter.service';
import { Utility } from '../shared/utility/utility';
import { AjaxService } from '../services/ajax.service';
import { UserDetailsService } from '../services/user-details.service';
import { mapNotifylocation } from '../shared/utility/config';
import { Location } from '@angular/common';
import * as _ from 'underscore';
import { HostedCashierPaymentsService } from '../services/hosted-cashier-payments.service';
import { PnpZimplerService } from '../services/pnp-zimpler.service';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NotificationComponent implements OnInit, OnDestroy {
  notifyBanners = [];
  langCode;
  userDetails;
  showNotification: boolean;
  showNotifyBanner: boolean;
  piqObject = {};
  destroy$: Subject<boolean> = new Subject<boolean>();


  constructor(
    private bannerService: BannerService,
    private router: Router,
    private emitter: EmitterService,
    private utils: Utility,
    private location: Location,
    private ajaxService: AjaxService,
    public userDetailsService: UserDetailsService,
    private paymentService:HostedCashierPaymentsService,
    private pnpService: PnpZimplerService
  ) {
    this.langCode = localStorage.getItem('langCode')
    this.emitter.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
      this.showNotifications();
    });

    // Subscribe to registration and subscription
    this.emitter.notificationEvent$.pipe(takeUntil(this.destroy$)).subscribe(call => {
      this.checkNotificationRibbons();
    });
    // // when userprofile is updated , check for notification ribbons are in sync with profile updates
    // this.updateUserDetailsSub = this.userDetailsService.userProfileUpdated$.subscribe(profile => {
    //   this.userDetails = this.userDetailsService.getUserProfileDetails();
    //   this.piqObject['userId'] = this.userDetails.playerID;
    //   this.checkNotificationRibbons();
    // });
    // Login Status
    this.emitter.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(loginStatus => {
      if(loginStatus) {  
        this.userDetails = this.userDetailsService.getUserProfileDetails();
        this.piqObject['userId'] = this.userDetails? this.userDetails.playerID : "";
        this.paymentService.getTokenPaymentIQ('cashier').pipe(takeUntil(this.destroy$)).subscribe((tokenData:any)=>{
          if (tokenData && tokenData.token) {
            this.piqObject['sessionId'] = tokenData.token;
            this.piqObject['merchantId'] = environment.paymentIqMID;
            this.checkNotificationRibbons(); 
          }
        });
      } else {
        this.notificationBanners();
      }
    });

    this.emitter.txnComplete$.pipe(takeUntil(this.destroy$)).subscribe(txnStatus => {
      this.userDetails = this.userDetailsService.getUserProfileDetails();
      if(this.userDetails) {
        this.piqObject['userId'] = this.userDetails.playerID;
        this.checkNotificationRibbons();
      }
    });

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        this.showNotifications();
      }
    });
  }

  ngOnInit() {

    this.showNotifications();
    this.notificationBanners();
  }

  // Show Notification ribbons only in specific pages
  showNotifications() {

    let locationPath=this.location.path();

    if(locationPath.indexOf("?")>0){
      const locationSplit=locationPath.split("?");
      locationPath = locationSplit[0];
    }

    for (let i = 0; i < mapNotifylocation.length; i++) {
      if (locationPath === "" || locationPath === "/" + this.langCode
      || locationPath.includes(mapNotifylocation[i])) {
        this.showNotification = true;
        break;
      } else {
        this.showNotification = false;
      }
    }
    window.scrollTo(0, 0);
  }


  checkNotificationRibbons() {

    let userName = this.userDetails.nickname;
    Promise.resolve(this.userDetailsService.checkUserProfile()).then(profileData => {

      if (!profileData['userProfileCompleted'] && !this.utils.getNotifyCookie('complete-profile' + userName)) {
        this.notificationBanners('complete-profile');
      } 
      else {
        this.checkSubscribeAndGeneralBanners();
      }
    });
  }

  checkPendingWithdrawsBanner() {
    let userName = this.userDetails.nickname;
    if (!this.utils.getNotifyCookie('pending-withdraws' + userName)) {
      if(this.userDetailsService.checkIsPNPUser()){
        let pendingWithdrawalObject = {
          cashoutVerifiedtxnRequired: true
        }
        this.pnpService.getPendingCashOuts(pendingWithdrawalObject).then(data=>{
          if(data && data.length > 0) {
            this.notificationBanners('pending-withdraws');
          } else {
            this.otherRibbonsInit(userName)
          }
        })
      } else if(!this.userDetailsService.checkIsPNPUser()){
        this.piqObject['merchantId'] = environment.paymentIqMID;
        let getPendingWithdrawalObject = _.clone(this.piqObject);
        getPendingWithdrawalObject['method'] = 'Withdrawal';
        getPendingWithdrawalObject['states'] = 'WAITING_APPROVAL';
        this.paymentService.getPendingWithdrawal(getPendingWithdrawalObject).pipe(takeUntil(this.destroy$)).subscribe((cashierData:any) => {
          if (cashierData && cashierData.success!=='false' && ( cashierData.transactions && cashierData.transactions.length > 0 )) {
            this.notificationBanners('pending-withdraws');
          } else {
            this.otherRibbonsInit(userName)
          }
        });
      }
    }else {
      this.otherRibbonsInit(userName)
    }
  }

  otherRibbonsInit(userName){
    if(!this.utils.getNotifyCookie('promotion' + userName)) {
      this.notificationBanners('promotion');
    }
  }
  checkSubscribeAndGeneralBanners() {
    let userName = this.userDetails.nickname;
    if(!this.utils.getNotifyCookie('subscribe-preference' + userName)) {
      if(!this.userDetailsService?.userPreferenceData){
        Promise.resolve(this.ajaxService.getSubscriptionPreferenes())
        .then(prefResposne => {
          this.updateNotifications(prefResposne)
        });
      }else{
        this.updateNotifications(this.userDetailsService?.userPreferenceData)
      }
      
    } else {
      this.checkPendingWithdrawsBanner();
    }
  }
  updateNotifications(prefResposne){
    this.userDetailsService.userPreferenceData = prefResposne;
        if (!prefResposne["emailSubscribed"] && !prefResposne["mobileSubscribed"]) {
          this.notificationBanners('susbscribePreference');
        } else {
          this.checkPendingWithdrawsBanner();
        }
  }

  // Notification banners
  notificationBanners(ribbonId?) {
   
    let zoneId = environment.notificationZoneID;
    Promise.resolve(this.bannerService.getBanners({ 'zoneId': zoneId }))
    .then(
      banners => {

        let self = this;

        // Notification Array make it Null
        self.notifyBanners = [];
        self.showNotifyBanner = false;

        // Loop Notification array
        _.each(banners, (banner) => {
          if (banner.targetMemberUrl === 'complete-profile' && ribbonId === 'complete-profile' && !this.userDetailsService.checkIsPNPUser()) {
            self.notifyBanners.push(banner);
          }else if (banner.targetMemberUrl === 'subscribe-preference' && ribbonId === 'susbscribePreference') {
            self.notifyBanners.push(banner);
          } else if (banner.targetMemberUrl === 'pending-withdraws' && ribbonId === 'pending-withdraws') {
            self.notifyBanners.push(banner);
          } else if (banner.targetMemberUrl === 'promotion' && ribbonId === 'promotion') {
            self.notifyBanners.push(banner);
          } 
          self.showNotifyBanner = true;
          banner.content = banner.content.replace(new RegExp('{{siteUrl}}', 'g'), environment.siteUrl);
        });

        // If Banners are empty for the given ribbonId
        // We need to Check banners for next ribbonId
        if(ribbonId && self.notifyBanners.length<=0){
          
          switch (ribbonId) {
            case 'complete-profile':
              this.checkSubscribeAndGeneralBanners();
              break;

            case 'susbscribePreference':
              this.checkPendingWithdrawsBanner();
              break;

            case 'pending-withdraws':
              this.notificationBanners('promotion');
              break;

            case 'promotion':
              this.showNotifyBanner=false;
              this.notifyBanners=[];
              break;
          }
          
        }


        self.notifyBanners = self.notifyBanners.map((banner)=>{

          let span=document.createElement('span');

          span.innerHTML=banner.content;

      
          /* Because we Have Same HTML for Desktop and Mobile coming from CMS and we have two buttons
          for each desktop and Mobile */
          let bannerButtons = span.querySelectorAll('.notify_banner--button');

          bannerButtons.forEach((bannerButton,index)=>{
            
            bannerButton.setAttribute('data-target', banner.targetUrl)
          });
          banner.content=span.innerHTML;

          return banner;

        });

        // self.showNotifyBanner = true;
        
        // Set Notification CTA links
        setTimeout(() => {
          
          // Notification CTA link functionality
          document.querySelectorAll('.notify_banner--button').forEach((ctaButton:HTMLElement)=>{
            ctaButton.addEventListener("click",function() {
              let target = ctaButton.getAttribute('data-target');
              if(target === "/completeprofile"){
                localStorage.removeItem('showRegisterPage');
                self.utils.goToCompleteProfile();      
              }
              else if (target === "/marketing-communication") {
                if(self.utils.isMobile()){
                  self.emitter.broadCastBannerPreferenceClick(true);
                }
                else{
                  self.router.navigate([self.langCode + '/myaccount'], { queryParams: { "openModal": "preferences"} });
                }
              } else {
                
                if(target){

                  let targetHasQueryParams=target.indexOf('?')===-1?false:true;
                  let targetSplit=target.split('?');
                  
                  if(targetHasQueryParams){

                    if(targetSplit[1]){
                        
                      let params:any=self.utils.parseQuery(targetSplit[1]);
                      params.time=new Date().getTime();

                      self.router.navigate(
                        [self.langCode], 
                        {
                          queryParams: params
                        }).then(()=>{
                          history.replaceState(null,"", self.router.createUrlTree([self.langCode]).toString())
                        });
                    }else{
                      self.router.navigate([self.langCode]);
                    }

                  }else{
                    self.router.navigate([self.langCode + target]);
                  }
                }else{

                  self.router.navigate([self.langCode]);
                }

              }
                let closeBtn:any = document.querySelector(".notify_banner--close-icon");
                    closeBtn.click();
            })
          });

          // Notification Close functionality
          let closeBtn = document.querySelector(".notify_banner--close-icon");

          if(closeBtn!==null){
            closeBtn.addEventListener("click",function() {
              let cookieName = this.getAttribute("data-setCookieName");
              let cookieTime = this.getAttribute("data-setCookieHours");
              self.setCookie(self, cookieName, cookieTime);
              self.closeNotifyBanners(cookieName);
            })
          }

        });
      }
    );
  }



  // Set Cookie on clicking on close button
  setCookie(self, cookieName, cookieTime){
    let userName = self.userDetails && self.userDetails.nickname ? self.userDetails.nickname : 'username';
    this.utils.setNotifyCookie(cookieName + userName, cookieTime);
  }

  // Close Notification Banners on cliking on Close button
  closeNotifyBanners(cookieName) {

    this.showNotifyBanner = false;
    this.checkNotificationRibbons();
  }

  // Mobile verification
  // codeVerify() {
  //   let logincredentials = {
  //     'email': this.userDetails.email,
  //     'channel': "sms"
  //   };
  //   Promise.resolve(this.ajaxService.resendEmailVerification(logincredentials))
  //   .then(regData => {
  //   },
  //   SystemError => {
  //     //this.emitter.broadcastserverError('', "/");
  //   });
  // }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
